export const INTEGRATION_CONFIG_PONTO_REFRESH_TOKEN = 'refreshToken';

export const pontoDefaultConfigurations = {
  [INTEGRATION_CONFIG_PONTO_REFRESH_TOKEN]: '',
};
